import {ChangeDetectorRef, Component} from '@angular/core';
import {Store} from "@ngrx/store";
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {DatabaseService} from "@cosbeni/database";
import {GapiSession} from "../gapi/gapi.session";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Capability, canWith, CAPS} from "../services/roles";
import * as wjcCore from "@mescius/wijmo";
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';


@Component({
    standalone: false,
    selector: 'app-user-container',
    templateUrl: './user-container.component.html',
    styleUrls: ['./appheader.css','./breadcrumbs.css','../../scss/common.css']
})
export class UserContainerComponent {
    database: string;
    user: any;
    breadcrumbs: Array<Object> = [];
    // テンプレートからケーパビリティ定数を参照するため公開する。
    readonly CAPS = CAPS;

    constructor(private router: Router, private route: ActivatedRoute, private store: Store<any>, private auth: AuthService, private databaseService: DatabaseService, private storage: StorageService, private config: ConfigService, private cdRef:ChangeDetectorRef) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if(wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded){
                this.user = digitalAuction.user.user;
            }
        });
        this.database = this.storage.get("database");
        this.router.events.pipe(
            filter(event => {
                return event instanceof NavigationEnd
            })
        ).subscribe(event => {
            this.breadcrumbs = [];
            let currentRoute = this.route.root,
                url = '';
            do {
                let childrenRoutes = currentRoute.children;
                currentRoute = null;
                childrenRoutes.forEach(route => {
                    if (route.outlet === 'primary') {
                        let routeSnapshot = route.snapshot;
                        url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                        this.breadcrumbs.push({
                            label: route.snapshot.data,
                            url: url
                        });
                        currentRoute = route;
                    }
                })

            } while (currentRoute);
        });
    }

    logout() {
        // token を消したあとログイン画面へ遷移する。
        this.auth.logout().subscribe(() => {
            this.storage.remove(this.database + "_url");
            this.router.navigate(['/login']);
        });
    }

    public hasRole(name: string): boolean {
        let result: boolean = false;
        if (wjcCore.isObject(this.user) && wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                if (role.name == name) {
                    result = true;
                }
            }
        }
        return result;
    }

    public enableMenu(name: string): boolean {
        let result: boolean = true;
        if (this.user[name])
            result = false;
        return result;
    }

    /** roles.ts のケーパビリティでメニュー可視性を判定する。 */
    public can(capability: Capability | Capability[]): boolean {
        return canWith(wjcCore.isObject(this.user) ? this.user.roles : null, capability);
    }
}
